import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'mobilePhoneFilter',
  pure: false
})
export class MobilePhoneFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, filterValue: string): any {
    if (!requestList || !filterValue) {
      return requestList;
    }
    const normalizedFilter = filterValue.toLowerCase();
    return requestList.filter(request =>
      (request.customer?.MobilePhone || '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
